import {
  ArticlesFullListEN,
  ArticlesFullListNO,
} from "@/components/ArticlesFullList";
import { Text } from "@/components/elements";
import ProductsFullList from "@/components/ProductsFullList";
import { I18nextLocale } from "@/types/types";

import styles from "./styles.module.css";

export const ArticleFooter = ({ products, t, locale }) => (
  <>
    <section className={styles.products}>
      <Text as="h2" size="l" responsive>
        {t("products_title")}
      </Text>
      <ProductsFullList products={products} />
    </section>
    <section className={styles.articles}>
      <Text as="h2" size="l" responsive>
        {t("other_articles_title")}
      </Text>
      {locale === I18nextLocale.NO_NO && <ArticlesFullListNO />}
      {locale === I18nextLocale.EN_NO && <ArticlesFullListEN />}
    </section>
  </>
);
